import { MinzeElement } from 'minze'

export interface LvcHelpIcon {}

export class LvcHelpIcon extends MinzeElement {
  html = () => `
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.14051 6.33884C7.86574 6.33884 7.64029 6.25429 7.46415 6.0852C7.28802 5.90907 7.19995 5.68714 7.19995 5.41942C7.19995 5.1517 7.28802 4.93329 7.46415 4.7642C7.64029 4.58807 7.86574 4.5 8.14051 4.5C8.41527 4.5 8.64073 4.58807 8.81686 4.7642C8.99299 4.93329 9.08106 5.1517 9.08106 5.41942C9.08106 5.68714 8.99299 5.90907 8.81686 6.0852C8.64073 6.25429 8.41527 6.33884 8.14051 6.33884ZM7.35847 7.08917H8.92254V12.5H7.35847V7.08917Z" fill="#1E007D"/>
      <rect x="0.5" y="1" width="15" height="15" rx="7.5" stroke="#1E007D"/>
    </svg>
 `

  css = () => `
    
  `
}
